import { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import style from "./youtube.module.css";
import { FALLBACK_YOUTUBE_CONFIG, YoutubeConfig, fetchYoutubeConfig } from "../cms/siteConfig";

export default function YoutubePage() {
  const [youtubeConfig, setYoutubeConfig] = useState<YoutubeConfig>(FALLBACK_YOUTUBE_CONFIG);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let active = true;

    fetchYoutubeConfig()
      .then((nextConfig) => {
        if (!active) return;
        setYoutubeConfig(nextConfig);
      })
      .finally(() => {
        if (!active) return;
        setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return (
    <>
      <Header />
      <section className={style["container--portfolio"]}>
        <div className={style["unit--content"]}>
          <h2 className={style["text--content"]}>Videos</h2>
          <p className={style["text--content--copy"]}>
            THE ENGINEER의 프로젝트와 비전을 영상으로 확인하세요
          </p>

          <div className={style["video-grid"]}>
            {youtubeConfig.videos.map((url, idx) => (
              <div key={`${url}-${idx}`} className={style["video-card"]}>
                <iframe
                  src={url}
                  title={`YouTube video ${idx + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className={style["video-iframe"]}
                />
              </div>
            ))}
          </div>

          {!isLoading && youtubeConfig.videos.length === 0 && (
            <p className={style["video-empty"]}>현재 등록된 영상이 없습니다.</p>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}
